/* eslint-disable no-unused-vars */
import React, { memo, useState } from "react";
import { Responsive, WidthProvider } from "react-grid-layout/legacy";
import { BiCopy } from "react-icons/bi";
import { FiEdit } from "react-icons/fi";
import { MdDeleteForever } from "react-icons/md";
import Swal from "sweetalert2";
import PropTypes from "prop-types";
import { v4 as uuid } from "uuid";

import { defaultLayout } from "@/utils/gridLayout";
import LayoutTextBox from "@/components/LayoutCharts/LayoutTextBox";

// !max tiles in height 18 width 12 for A4 size report

const ResponsiveReactGridLayout = WidthProvider(Responsive);

const componentPreview = {
  bar: "/img/chart/bar.png",
  line: "/img/chart/line.png",
  pie: "/img/chart/pie.png",
  counter: "/img/chart/counter.png",
  splitCounter: "/img/chart/split-counter.png",
  textBox: "/img/chart/text-box.png",
  dial: "/img/chart/dial.png",
  tank: "/img/chart/tank.png",
  table: "/img/chart/table.png",
  dynamicBox: "/img/chart/dynamicBox.png",
};

const CustomReportTemplateLayout = memo(({ gridData, setGridData, setLayouts, layouts, mode }) => {
  const [editId, setEditId] = useState("");
  const [show, setShow] = useState(false);

  const onLayoutChange = (layout, data) => {
    data.lg?.forEach((layoutItem) => {
      if (layoutItem.h + layoutItem.y >= 18) {
        layoutItem.y = 18 - layoutItem.h;
      }
    });
    // console.log(layout);
    setLayouts(data);
  };

  const handlerRemove = (id) => {
    const newData = gridData.filter((data) => data._id !== id);
    setGridData(newData);
  };

  const handlerUpdate = (id) => {
    setEditId(id);
    setShow(true);
  };

  const handleCopy = (item) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to copy this tile?.",
      //icon: "warning",
      dangerMode: true,
      showCancelButton: true,
      confirmButtonText: "Confirm",
    }).then((result) => {
      if (result.isConfirmed) {
        setGridData([
          ...gridData,
          {
            ...item,
            _id: uuid(),
            chartTitle: item.chartTitle + " (copy)",
          },
        ]);
      }
    });
  };

  const handleRemove = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to remove this tile?.",
      //icon: "warning",
      dangerMode: true,
      showCancelButton: true,
      confirmButtonText: "Confirm",
    }).then((result) => {
      if (result.isConfirmed) {
        handlerRemove(id);
      }
    });
  };

  return (
    <>
      <ResponsiveReactGridLayout
        className={`layout ${mode === "view" ? "bg-white client_view" : ""}`}
        id="layout1"
        rowHeight={80}
        layouts={layouts}
        onLayoutChange={onLayoutChange}
        draggableCancel=".clickBtn"
        isDraggable={mode === "view" ? false : true}
        isResizable={mode === "view" ? false : true}
        compactType={null}
        // cols={{ lg: 16, md: 12, sm: 8, xs: 4, xxs: 2 }}
        // breakpoints={{ lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 }}
        breakpoints={{ lg: 900, md: 700, sm: 500, xs: 400, xxs: 300 }}
        cols={{ lg: 16, md: 12, sm: 8, xs: 4, xxs: 2 }}
        preventCollision={true}
      >
        {gridData?.map((item, idx) => (
          <div
            className="bg-white"
            style={{ userSelect: "none" }}
            key={item._id}
            data-grid={layouts?.lg?.[idx] || defaultLayout}
          >
            <div className="position-relative h-100 d-flex align-items-center p-2 pt-4 justify-content-center">
              {/* {["superAdmin", "businessAdmin"].includes(userDetails.role) && mode !== "view" ? ( */}
              {mode !== "view" ? (
                <div
                  className="d-flex justify-content-end align-items-center position-absolute"
                  style={{ top: 0, right: 5, zIndex: 10 }}
                >
                  <div className="clickBtn" onClick={() => handleCopy(item)}>
                    <BiCopy className="text-secondary me-2" />
                  </div>
                  <div className="clickBtn" onClick={() => handlerUpdate(item._id)}>
                    <FiEdit className="text-secondary me-1" />
                  </div>
                  <div className="clickBtn" onClick={() => handleRemove(item._id)}>
                    <MdDeleteForever className="fs-5 text-secondary" />
                  </div>
                </div>
              ) : (
                ""
              )}
              {item.component === "textBox" ? (
                <LayoutTextBox data={item} />
              ) : (
                <img src={componentPreview[item.component]} alt={item.component} style={{ maxHeight: "100%" }} />
              )}
            </div>
          </div>
        ))}
      </ResponsiveReactGridLayout>
    </>
  );
});

export default CustomReportTemplateLayout;

CustomReportTemplateLayout.displayName = "CustomReportTemplateLayout";
CustomReportTemplateLayout.propTypes = {
  gridData: PropTypes.array,
  setGridData: PropTypes.func,
  setLayouts: PropTypes.func,
  layouts: PropTypes.object,
  mode: PropTypes.string,
};
